import React, { FC } from 'react'
import { Breakdown } from '../../Breakdown'
import { buildBreakdownLedgerRows } from '../../BreakdownLedger'
import { useTranslation } from 'react-i18next'
import getLocaleCurrencyForAmount from '../../../../../utils/getLocaleCurrencyForAmount'
import { BreakDownLedgerVariants } from '../../BreakdownLedger'
import { LedgerRow } from '../../../../Table/LedgerTable'
import { convertTwoDecimalStringToBig } from '../../../../../utils/bigJSHelper'

interface LicenseFeeSectionProps {
  title: string
  rows: {
    label: string
    feeAmount: string
    numberOfStudents: number
    studentInfoSubTotal: string
    currencyCode: string
  }[]
  subtotal: string
}

const LicenseFeeSection: FC<LicenseFeeSectionProps> = ({
  title,
  rows,
  subtotal,
}) => {
  const { t } = useTranslation()

  const [firstStudent, additionalStudent] = rows
  const breakdownRows: LedgerRow[] = []

  if (title) {
    breakdownRows.push(
      buildBreakdownLedgerRows(
        {
          content: t('LicenseFeeSection.Row.FirstStudents', '{{feeName}}', {
            feeName: title,
          }),
          color: 'main',
          cellCssProps: {
            fontWeight: 'bold',
            width: '25%',
          },
        },
        {
          content: ' ',
        },
        {
          content: ' ',
        },
        {
          content: ' ',
        }
      )
    )
  }

  if (convertTwoDecimalStringToBig(firstStudent.studentInfoSubTotal).gt(0)) {
    breakdownRows.push(
      buildBreakdownLedgerRows(
        {
          content: t('LicenseFeeSection.Row.FirstStudents', 'First Students'),
          cssTextProps: {
            marginLeft: 0,
          },
          cellCssProps: {
            width: '25%',
          },
        },
        {
          content: getLocaleCurrencyForAmount(
            firstStudent.feeAmount,
            firstStudent.currencyCode
          ),
          cellCssProps: {
            width: '25%',
          },
        },
        { content: `${firstStudent.numberOfStudents}` },
        {
          content: getLocaleCurrencyForAmount(
            firstStudent.studentInfoSubTotal,
            firstStudent.currencyCode
          ),
          cellCssProps: {
            width: '25%',
          },
        }
      )
    )
  }

  if (
    convertTwoDecimalStringToBig(additionalStudent.studentInfoSubTotal).gt(0)
  ) {
    breakdownRows.push(
      buildBreakdownLedgerRows(
        {
          content: t(
            'LicenseFeeSection.Row.AdditionalStudents',
            'Additional Students'
          ),
          cssTextProps: {
            marginLeft: 0,
          },
          cellCssProps: {
            width: '25%',
          },
        },
        {
          content: getLocaleCurrencyForAmount(
            additionalStudent.feeAmount,
            additionalStudent.currencyCode
          ),
        },
        {
          content: `${additionalStudent.numberOfStudents}`,
          cellCssProps: {
            width: '25%',
          },
        },
        {
          content: getLocaleCurrencyForAmount(
            additionalStudent.studentInfoSubTotal,
            additionalStudent.currencyCode
          ),
          cellCssProps: {
            width: '25%',
          },
        }
      )
    )
  }

  breakdownRows.push(
    buildBreakdownLedgerRows(
      {
        content: t('LicenseFeeSection.Row.Subtotal', 'Subtotal'),
        color: 'main',
        cssTextProps: {
          marginLeft: 0,
          padding: 0,
        },
        cellCssProps: {
          width: '25%',
        },
      },
      {
        content: getLocaleCurrencyForAmount(
          subtotal,
          firstStudent.currencyCode
        ),
        color: 'main',
        colSpan: 3,
        cssTextProps: {
          fontWeight: 'bold',
          fontSize: 16,
        },
        cellCssProps: {
          width: '25%',
        },
      }
    )
  )

  return (
    <Breakdown
      breakdownRows={breakdownRows}
      cellStyles={{
        // ensures all rows are displayed uniformly
        padding: 0,
        height: 50,
      }}
      variant={BreakDownLedgerVariants.Normal}
    />
  )
}

export default LicenseFeeSection
